import './filter-guide.less';
import guideModalCtrl from './filter-guide.modal.ctrl';

export default angular.module('cian.newbuild.filter.guide', ['ui.cian.modal'])
    .directive('filterGuide', () => ({
        restrict: 'A',
        controller: [
            '$log',
            '$uibModal',
            '$window',
            'FilterService',
            'RegionUtilsService',
            ($log, $uibModal, $window, FilterService, RegionUtilsService) => {
                const ctrl = {};

                // Гайд только для Москвы и МО
                if (RegionUtilsService.isMoscowOrMO(FilterService.selectedRegions)) {
                    // Показываем гайд только один раз
                    if ($window.localStorage.getItem('seenFilterGuideMO')) {
                        return;
                    }

                    $uibModal.open({
                        animation: true,
                        windowClass: 'serp-modal filter-guide-modal',
                        backdropClass: 'serp-modal-backdrop',
                        template: require('./filter-guide.modal.jade'),
                        controller: guideModalCtrl,
                        controllerAs: 'guide',
                        keyboard: false,
                        resolve: {}
                    }).result.finally(() => {
                        // Запоминаем, что пользователь видел гайд
                        $window.localStorage.setItem('seenFilterGuideMO', '1');
                    });
                }

                return ctrl;
            }],
    }))
    .name;



// WEBPACK FOOTER //
// ./src/serp/directives/filter-guide/filter-guide.dir.js